module.exports = __webpack_public_path__ + "img/invite-admin-members.cb664ec9.png";